import * as types from "./types";
import {
  getProductAxios,
  getProductIDAxios,
  deleteProductAxios,
  postProductAxios,
  putProductAxios,
  postProductFileAxios,
  deleteProductimageAxios,

  getProductDocumentList,
  deleteProductDocument,
  uploadProductMultipleDocuments,
  uploadProductDocument,
  downloadProductDocument
} from "./services";

export async function getProductListAction({ commit }, isActive = null) {
  commit(types.LOADING_PRODUCT, true);
  try {
    const { data } = await getProductAxios(isActive);
    commit(types.GET_PRODUCT_LIST, data.result.data);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_PRODUCT, false);
  }
}

export async function getProductIDAction({ commit }, payload) {
  commit(types.LOADING_PRODUCT, true);
  try {
    const { data } = await getProductIDAxios(payload);
    commit(types.GET_PRODUCT_ID, data.result);
    return data.result;
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_PRODUCT, false);
  }
}

export async function removeProductAction({ commit }, payload) {
  commit(types.LOADING_PRODUCT, true);
  try {
    await deleteProductAxios(payload);
    commit(types.REMOVE_PRODUCT, payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_PRODUCT, false);
  }
}

// Function to add a product
export async function addProductAction({ commit }, payload) {
  commit(types.LOADING_PRODUCT, true);
  try {
    // Post the product data
    const data = await postProductAxios(payload.product);
    // Extract the id from the response data
    const productId = data.data.result.productId;
    // Check if productId is defined
    if (productId) {
      payload.product.id = productId;
      commit(types.ADD_PRODUCT, payload.product);
      // If there's a file, post the product file
      if (payload.file) {
        await postProductFileAxios({
          itemId: payload.product.id,
          file: payload.file,
        });
      }  
    }
  } catch (e) {
    // Log the error for debugging
    console.error("Error in addProductAction:", e);
    throw e;
  } finally {
    commit(types.LOADING_PRODUCT, false);
  }
}

export async function updateProductAction({ commit }, payload) {
  commit(types.LOADING_PRODUCT, true);
  try {
    const data = await putProductAxios(payload.product);
    payload.product.id = data.data.result.id;
    commit(types.UPDATE_PRODUCT, payload.product);
    if (payload.file === "__removed__") {
      await deleteProductimageAxios(payload.product.id);
    } else if (payload.file) {
      await postProductFileAxios({
        itemId: payload.product.id,
        file: payload.file,
      });
    }
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_PRODUCT, false);
  }
}

export async function addProductFileAction({ commit }, payload) {
  commit(types.LOADING_PRODUCT, true);
  try {
    await postProductFileAxios(payload);
  } catch (e) {
    throw e;
  } finally {
    commit(types.LOADING_PRODUCT, false);
  }
}

export async function getProductDocumentListAction({ commit }, id) {
  commit(types.LOADING_PRODUCT_DOCUMENT, true);
  try {
      const { data } = await getProductDocumentList(id);
      commit(types.GET_PRODUCT_DOCUMENT_LIST, data.data);
  }
  catch (e) {
      throw e;
  }
  finally {

      commit(types.LOADING_PRODUCT_DOCUMENT, false);
  }
}

export async function removeProductDocumentAction({ commit }, payload) {
  commit(types.LOADING_PRODUCT_DOCUMENT, true);
  try {
      await deleteProductDocument(payload);
      commit(types.REMOVE_PRODUCT_DOCUMENT, payload);
  }
  catch (e) {

      throw e;
  }
  finally {
      commit(types.LOADING_PRODUCT_DOCUMENT, false);
  }
}

export async function downloadProductDocumentAction({ commit }, payload) {
  commit(types.LOADING_PRODUCT_DOCUMENT, true);
  try {
      await downloadProductDocument(payload);
      commit(types.DOWNLOAD_PRODUCT_DOCUMENT, payload);
  }
  catch (e) {

      throw e;
  }
  finally {
      commit(types.LOADING_PRODUCT_DOCUMENT, false);
  }
}


export async function uploadProductDocumentAction({ commit }, {payload, referenceId = null, type = null, typeId = null}) {
  commit(types.LOADING_PRODUCT_DOCUMENT, true);
  try {
      await uploadProductDocument(payload, referenceId, type, typeId);
      commit(types.ADD_PRODUCT_DOCUMENT, payload);
  }
  catch (e) {

      throw e;
  }
  finally {
      commit(types.LOADING_PRODUCT_DOCUMENT, false);
  }
}


export async function uploadProductMultipleDocumentAction({ commit }, {payload, referenceId = null, type = null, typeId = null}) {
  commit(types.LOADING_PRODUCT_DOCUMENT, true);
  try {
      await uploadProductMultipleDocuments(payload, referenceId, type, typeId);
      commit(types.ADD_PRODUCT_MULTI_DOCUMENT, payload);
  }
  catch (e) {

      throw e;
  }
  finally {
      commit(types.LOADING_PRODUCT_DOCUMENT, false);
  }
}
